<template>
	<div style="position: relative">
		<div class="ul">
			<div class="li" v-for="(item,index) in questionList" :key="index">
				<input type="checkbox" class="cheaked" name="cheaked" @click="cheak($event,item)"
					   :checked="item.checked" v-model="questionList[index].checked"></input>
				<div class="li-top">
					<div>
						<span>{{ item.qtpye }}</span>
					</div>
					<div>
						<span>{{ item.id }}题</span>
					</div>
				</div>
				<div class="li-con">
					<p v-html="item.title"></p>
				</div>
				<div class="li-da">
					<span v-if="item.option_a">A:{{ item.option_a }}</span>
					<span style="margin-left:20px"></span>
					<span v-if="item.option_b">B:{{ item.option_b }}</span>
					<span style="margin-left:20px"></span>
					<span v-if="item.option_c">C:{{ item.option_c }}</span>
					<span style="margin-left:20px"></span>
					<span v-if="item.option_d">C:{{ item.option_d }}</span>
				</div>
				<div class="li-da">
					<span v-html="item.answer1"></span>
				</div>
				<div style="margin-top: 10px">
					<span v-html="item.answer2"></span>
				</div>
				<div class="li-jx">
					<p v-html="item.parse"></p>
				</div>
			</div>
		</div>
		<div v-if="this.questionList.length==0" style="display: flex;justify-content: center;align-content: center;">
			<img src="/web/static/img/nodata.e655c15.png" style="width: 500px;height: 500px;">
		</div>
		<el-dialog
			title="习题篮"
			:visible.sync="open"
			width="30%"
			center>
			<div class="mes">
				<div>
					<span>作业名称</span>
					<input v-model="jobname" placeholder="请选择作业名称" maxlength="12"></input>
					<span style="color:#00ad61">0/12</span>
				</div>
				<div>
					<span>选择年级</span>
					<el-select v-model="gradName" placeholder="请选择年级" @change="getGradId">
						<el-option
							v-for="item in gradList"
							:key="item.id"
							:label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
				<div>
					<span>选择学科</span>
					<el-select v-model="subjectName" placeholder="请选择学科" @change="getSubjectId">
						<el-option
							v-for="item in subjectList"
							:key="item.id"
							:label="item.name"
							:value="item.name">
						</el-option>
					</el-select>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancel()">取 消</el-button>
    			<el-button type="primary" @click="groupIssued()">确 定</el-button>
  			</span>
		</el-dialog>
		<div class="btn" style="position: fixed;bottom: 30px;">
			<span>已选习题({{ questionList ? questionList.length : '0' }})</span>
			<el-button @click="checkAl()" class="btn1">{{ qx }}</el-button>
			<el-button @click="dele()" class="btn2">删除</el-button>
			<el-button @click="commit()" class="btn3">生成组卷</el-button>
		</div>
	</div>
</template>

<script>
import pagination from '../../pagination/pagination.vue';

export default {
	components: {
		pagination
	},
	data() {
		return {
			num: 0,
			id: '',
			open: false,
			checkAll: false,
			qx: '全选',//全选文字切换
			cheaked: [],
			value: "",
			jobname: '',//作业名称
			gradeId: '',//年级id
			gradName: '',//年级名称
			subjectId: '',//学科id
			subjectName: '',//学科名称
			onlineName: '',//线上线下名字
			subjectList: [],//学科列表
			gradList: [],//年级列表
			questionList: [],//习题篮列表
			teachid: '',//教师id
		}
	},
	created() {
		this.id = this.$route.query.id;
		//习题篮列表
		this.questionList = JSON.parse(localStorage.getItem('dataList')) ? JSON.parse(localStorage.getItem('dataList')) : []
		//教师id
		this.teachid = JSON.parse(localStorage.getItem('user')) ? JSON.parse(localStorage.getItem('user')).id : ''
		//获取年级
		this.getGrad()
		//获取学科
		this.getSubject()
	},
	methods: {
		//获取年级id
		getGradId(name) {
			this.gradList.forEach((value, index) => {
				if (value.name == name) {
					this.gradeId = value.id
				}
			})
		},
		//获取年级
		getGrad() {
			this.$request.ajax(this).post("/Library/grade").then(res => {  //年级
				this.gradList = res.data
			})
		},
		//获取学科
		getSubjectId(name) {
			let subjectId = ''
			this.subjectList.forEach((value, index) => {
				if (value.name == name) {
					subjectId = value.id
				}
			})
			//学科id对应
			switch (subjectId) {
				case "1":
					this.subjectId = "1";
					break;
				case "2":
					this.subjectId = "2";
					break;
				case "3":
					this.subjectId = "3";
					break;
				case "4":
					this.subjectId = "6";
					break;
				case "5":
					this.subjectId = "9";
					break;
				case "6":
					this.subjectId = "7";
					break;
				case "7":
					this.subjectId = "8";
					break;
				case "8":
					this.subjectId = "4";
					break;
				case "9":
					this.subjectId = "5";
					break;
			}
		},
		//获取学科id
		getSubject() {
			this.subjectList = []
			let obj = {}
			obj.id = this.questionList[0] ? this.questionList[0].subjectId : ''
			obj.name = JSON.parse(localStorage.getItem('subjectName2')).replace("\"","").replace("\"","")
			this.subjectList.push(obj)
		},
		//删除已选
		dele() {
			this.cheaked.forEach((value1, index1) => {
				this.questionList.forEach((value, index) => {
					if (value1 == value) {
						this.questionList.splice(index, 1)
					}
				})
			})
			localStorage.removeItem('dataList')
			localStorage.setItem('dataList', JSON.stringify(this.questionList))
		},
		//全选
		checkAl() {
			let cheaked = document.getElementsByName("cheaked")
			if (this.checkAll) {
				//取消全选
				this.checkAll = !this.checkAll
				this.qx = "全选"
				this.questionList.forEach((value, index) => {
					cheaked[index].checked = false
				})
				this.cheaked = []
			} else {
				this.checkAll = !this.checkAll
				this.questionList.forEach((value, index) => {
					cheaked[index].checked = true
					this.cheaked.push(value)
				})
				this.qx = "取消全选"
			}
		},
		cheak(e, val) {
			if (e.target.checked) {
				this.cheaked.push(val)
			} else {
				this.cheaked.pop(val)
			}
		},
		cancel() {
			this.open = !this.open
			this.$message("已取消");
		},
		//组卷选择
		commit() {
			this.$confirm('是否提交到慧题库后台', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info',
				center: true
			}).then(() => {
				this.open = !this.open
				this.$message({
					type: 'success',
					message: '已确定!'
				});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		//组卷下发
		groupIssued() {
			if (!this.questionList || !this.jobname || !this.gradeId || !this.subjectId) {
				this.$message({
					type: 'warning',
					message: '请填写完整!'
				});
			} else {
				let data = {}
				data.grade = this.gradeId
				data.question_list = this.questionList
				this.$request.ajax(this).post('/api_teacher/question_createList', data).then((res) => {
					if (res.msg == 'success') {
						let data1 = {}
						data1.name = this.jobname
						data1.subject = this.subjectId
						data1.grade = this.gradeId
						data1.question_ids = res.data.id
						this.$request.ajax(this).post('/api_teacher/exercise_book_create', data1).then((res1) => {
							if (res1.msg == 'success') {
								this.$message({
									type: 'success',
									message: '组卷生成成功!'
								});
								this.open = false
							} else {
								this.$message({
									type: 'error',
									message: '组卷生成失败!'
								});
								this.open = false
							}
						})
					}
				})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.ul .li .li-top div:nth-child(1) {
	flex: 1;
}

.ul .li .li-top div:nth-child(2) {
	with: 500px;
	color: #00ad61;
	text-align: right;
}

.btn {
	padding: 0px 220px 50px;
	margin-bottom: 20px;

	.btn1 {
		margin-left: 350px;
		background-color: #00ad61;
		color: #FFFFFF;
	}

	.btn2 {
		background-color: #ff0019;
		color: #FFFFFF;
	}

	.btn3 {
		background-color: #F7A22C;
		color: #FFFFFF;
	}
}

.cheaked {
	transform: translate(-50px, 80px);
}

.mes {
	padding-left: 120px;

	div {
		margin-top: 10px;
	}
}

.ul .li:last-of-type {
	margin-bottom: 80px;
}

.ul {
	padding: 0px 220px 50px;

	.li {
		padding: 20px 0;
		border-bottom: 1px solid #e6e6e6;
		margin: 0 20px;
		border-bottom: 1px solid #e6e6e6;

		.li-top {
			display: flex;
		}

		.li-con {
			margin-top: 20px;
		}

		.li-da {
			margin-top: 20px;
		}

		.li-jx {
			margin-top: 20px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/huiBasket.vue